var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.901,
    height: 15.128,
    viewBox: "0 0 15.901 15.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7175",
    "data-name": "Group 7175",
    transform: "translate(-720 -183.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7171",
    "data-name": "Group 7171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-new-releases",
    "data-name": "Icon material-new-releases",
    d: "M17.4,9.87,15.637,7.861l.246-2.66-2.609-.593-1.366-2.3L9.45,3.365,6.993,2.31l-1.366,2.3-2.609.585.246,2.66L1.5,9.87l1.764,2.009-.246,2.667,2.609.593,1.366,2.3L9.45,16.375l2.457,1.055,1.366-2.3,2.609-.593-.246-2.66Z",
    transform: "translate(718.5 181.689)",
    fill: "#006dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36165",
    "data-name": "Path 36165",
    d: "M726.194,195.446l-2.282-3.394,1.452-.977,1.288,1.916L730.933,190l1,1.435Z",
    transform: "matrix(0.978, -0.208, 0.208, 0.978, -24.162, 154.555)",
    fill: "#fffae5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.5800d4455c59273313d100f2d4eded3c.svg";
export { ForwardRef as ReactComponent };